import { render } from "./Netkill.vue?vue&type=template&id=26472e22&scoped=true"
import script from "./Netkill.vue?vue&type=script&lang=js"
export * from "./Netkill.vue?vue&type=script&lang=js"

import "./Netkill.vue?vue&type=style&index=0&id=26472e22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26472e22"]])

export default __exports__